import React, { memo } from 'react';

import PropTypes from 'prop-types';

import {
  Box,
  Fade,
} from '@mui/material';

import LinearProgressWithLabel from '../pages/Common Component/LinearProgressWithLabel';

import useProgressTimer from '../hooks/useProgressTimer';

function TimedLinearProgressWithLabel({
  active,
  durationMs = 4000,
  tickMs = 50,
  maxValue = 95,
  startValue = 0,
  resetOnStart = true,
  label,
  showPercentage = true,
  sx = {},
  ...other
}) {

  const {
    progress,
    visible,
  } = useProgressTimer({
    active,
    durationMs,
    tickMs,
    maxValue,
    startValue,
    resetOnStart,
  });

  if (!visible) {
    return null;
  }
  return (

    <Fade in={visible} timeout={300}>

      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        {...other}
        sx={{
          py: 2,
          height: '200px',
          width: '100%',
          ...sx,
        }}
      >

        <Box sx={{ width: '50%' }}>

          <LinearProgressWithLabel
            value={progress}
            label={label}
            showPercentage={showPercentage}
          />

        </Box>

      </Box>

    </Fade>
  );
}

TimedLinearProgressWithLabel.propTypes = {
  active: PropTypes.bool.isRequired,
  durationMs: PropTypes.number,
  tickMs: PropTypes.number,
  maxValue: PropTypes.number,
  startValue: PropTypes.number,
  resetOnStart: PropTypes.bool,
  label: PropTypes.string,
  showPercentage: PropTypes.bool,
  sx: PropTypes.object,
};

export default memo(TimedLinearProgressWithLabel);